import { apiPost } from "../api/client";
import type { Me } from "../api/types";

export default function UserMenu({ me }: { me: Me }) {
    const logout = async () => {
        try {
            await apiPost("/auth/logout");
        } catch {
            // session may already be gone; reload either way
        }
        window.location.reload();
    };
    return (
        <div className="user-menu">
            <span title={me.username}>{me.name}</span>
            <span className={`role-badge ${me.role}`}>{me.role}</span>
            <button className="btn btn-small" onClick={() => void logout()}>
                Sign out
            </button>
        </div>
    );
}
